export default "__VITE_ASSET__BLDcyl6I__"